import { getValue, fetchAndActivate } from 'firebase/remote-config'

export default defineNuxtPlugin(() => {
  let checkInterval: NodeJS.Timeout | null = null

  const startMaintenanceMonitoring = () => {
    // Don't start monitoring if we're on maintenance page
    if (process.client && window.location.pathname === '/maintenance') {
      return
    }

    console.log('Starting background maintenance monitoring...')

    const checkMaintenanceMode = async () => {
      try {
        // Get Firebase Remote Config
        const { $firebaseRemoteConfig } = useNuxtApp()
        
        if (!$firebaseRemoteConfig) {
          return
        }

        // Fetch latest config
        await fetchAndActivate($firebaseRemoteConfig)
        
        // Check maintenance mode flag
        const maintenanceMode = getValue($firebaseRemoteConfig, 'maintenance_mode')
        const isMaintenanceActive = maintenanceMode.asBoolean()
        
        if (isMaintenanceActive) {
          console.log('Maintenance mode activated - redirecting to maintenance page')
          // Clear interval since we're redirecting
          if (checkInterval) {
            clearInterval(checkInterval)
            checkInterval = null
          }
          return navigateTo('/maintenance')
        }
        
      } catch (error) {
        // Log error but don't spam console - only log once per minute
        const errorMessage = error instanceof Error ? error.message : String(error)
        if (errorMessage.includes('installations') || errorMessage.includes('INVALID_ARGUMENT')) {
          // This is a configuration error - stop monitoring to avoid spam
          if (checkInterval) {
            clearInterval(checkInterval)
            checkInterval = null
          }
          console.warn('Firebase configuration issue detected - maintenance monitoring disabled')
        } else {
        console.error('Error checking maintenance mode:', error)
        }
      }
    }

    // Check immediately
    checkMaintenanceMode()

    // Then check every 30 seconds
    checkInterval = setInterval(checkMaintenanceMode, 30000)
  }

  const stopMaintenanceMonitoring = () => {
    if (checkInterval) {
      clearInterval(checkInterval)
      checkInterval = null
      console.log('Stopped background maintenance monitoring')
    }
  }

  // Start monitoring when plugin loads (on client side)
  if (process.client) {
    startMaintenanceMonitoring()
  }

  // Clean up on page unload
  if (process.client) {
    window.addEventListener('beforeunload', stopMaintenanceMonitoring)
  }

  return {
    provide: {
      startMaintenanceMonitoring,
      stopMaintenanceMonitoring
    }
  }
})
